import {BaseModel} from '../../base/models/base-model.model';
import {Status} from '../DTO/status';

export class AccountModel extends BaseModel {
  /**
   * Account Code
   */
  private _accountCode?: string;
  /**
   * Customer Code
   */
  private _customerCode?: string;
  /**
   * Account Description
   */
  private _description?: string;
  /**
   * Account Contact Mail
   */
  private _mail?: string;
  /**
   * Account with mandatory contract
   */
  private _mandatoryContract?: boolean;
  private _status: Status;
  /**
   * Account Reference Unit
   */
  private _unit?: boolean;

  constructor(accountCode?: string, customerCode?: string, description?: string, mail?: string, mandatoryContract?: boolean, status?: Status, unit?: boolean) {
    super();
    this._accountCode = accountCode;
    this._customerCode = customerCode;
    this._description = description;
    this._mail = mail;
    this._mandatoryContract = mandatoryContract;
    this._status = status;
    this._unit = unit;
  }

  get accountCode(): string {
    return this._accountCode;
  }

  set accountCode(value: string) {
    this._accountCode = value;
  }

  get customerCode(): string {
    return this._customerCode;
  }

  set customerCode(value: string) {
    this._customerCode = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get mail(): string {
    return this._mail;
  }

  set mail(value: string) {
    this._mail = value;
  }

  get mandatoryContract(): boolean {
    return this._mandatoryContract;
  }

  set mandatoryContract(value: boolean) {
    this._mandatoryContract = value;
  }

  get status(): Status {
    return this._status;
  }

  set status(value: Status) {
    this._status = value;
  }

  get unit(): boolean {
    return this._unit;
  }

  set unit(value: boolean) {
    this._unit = value;
  }

  stringify(): string {
    return this.accountCode + ' ' + this.description ? this.description : '';
  }
}
